import React from 'react'
import { Button } from 'antd'
import classnames from 'classnames'
import './styles.scss'

export default ({title, description, content, click_text, error, on_click}) => (
  <div className='empty-state'>
    <div>
      <span className={classnames({ 'error': error })}>
        {title ? title : 'No content found'}
      </span>

      <span className={classnames({ 'error': error })}>
        {description}
      </span>
    </div>

    <Button className={'ant-btn'} onClick={e=>{
        e.stopPropagation()
        on_click()
      }
    }>
      <span>{click_text ? click_text : 'Refresh'}</span>
    </Button>

      {content}
  </div>
)
